import React, { Component } from 'react'
import axios from 'axios'
import '../../styles/Form.scss'
import actions from '../../actions'
import store from '../../store'
import Loader from '../Loader'
import Field from './Field'

class Form extends Component {

  constructor() {
    super()

    this.state = {
      loading: null,
      fields: [],
      success: null,
      error: null
    }

    this.submit = this.submit.bind(this)
  }

  static propTypes = {
    name: React.PropTypes.string.isRequired,
    url: React.PropTypes.string.isRequired,
    fields: React.PropTypes.array.isRequired,
    onSuccess: React.PropTypes.func.isRequired,
    onError: React.PropTypes.func.isRequired,
    xhrSuccessMsg: React.PropTypes.string.isRequired,
    xhrErrorMsg: React.PropTypes.string.isRequired,
    form: React.PropTypes.object.isRequired
  }

  submit(e) {
    e.preventDefault()
    let error = null
    let POST = {}

    // Check for errors and set POST values
    this.state.fields.forEach(field => {
      const { input, required, value } = field
      const { name } = input
      if (error) return
      if (field.error) {
        error = 'Please fix form errors.'
        return
      }
      if (required && !value) {
        error = 'Please fill out required fields.'
        return
      }
      if (name) POST[name] = value
    })

    // Display error
    this.setState({ error })

    // Issue xhr if no error
    if (!error) this.issueXHR(POST)
  }

  async issueXHR(POST) {
    // Dispatch form submit action
    const { name, url, onSuccess, onError, xhrSuccessMsg, xhrErrorMsg } = this.props
    store.dispatch( actions.disableForm(name) )

    // Show loading
    this.setState({ loading: true })

    // Issue XHR
    const handleError = e => {
      console.error(e)
      store.dispatch( actions.enableForm(name) )
      this.setState({
        loading: false,
        error: xhrErrorMsg
      })
      onError(e)
    }

    try {
      const res = await axios.post(url, POST)
      if (!res || !res.data) return handleError(null)
      this.setState({
        loading: false,
        success: xhrSuccessMsg
      })
      store.dispatch(
        actions.submitForm(name, xhrSuccessMsg)
      )
      onSuccess(res.data)
    }
    catch(e) { handleError(e) }
  }

  componentDidMount() {
    const { fields } = this.props
    this.setState({ fields })
  }

  render() {
    const { name, fields, form } = this.props
    if (this.state.success || form.submitted) {
      return (
        <div className="FormSuccess">
          <p>{this.state.success || form.successMsg}</p>
        </div>
      )
    }
    return (
      <form className={name} action="#" method="POST" onSubmit={this.submit}>
        { this.state.loading ? <Loader name="oval" /> : null }
        {fields.map((field, i) => <Field {...field} key={i} form={this} index={i} />)}
        { this.state.error ? <p className="error">{this.state.error}</p> : null }
      </form>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Form/Form.js